import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  query: '',
  results: [],
  isLoading: false,
  isError: false,
  message: '',
  filters: {
    category: '',
    priceRange: [0, 10000],
    moq: '',
    location: '',
    leadTime: '',
  },
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.message = '';
    },
    setQuery: (state, action) => {
      state.query = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearSearch: (state) => {
      state.query = '';
      state.results = [];
    },
  },
});

export const { reset, setQuery, setFilters, clearSearch } = searchSlice.actions;
export default searchSlice.reducer;